"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var react_1 = __importDefault(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var classnames_1 = __importDefault(require("classnames"));
var styles = __importStar(require("./Layout.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var Layout = function (_a) {
    var _b;
    var attributes = _a.attributes, columns = _a.columns, gap = _a.gap, padding = _a.padding, alignment = _a.alignment;
    if (columns.length === 0)
        return null;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.layout), style: (0, dynamic_1.assignInlineVars)((_b = {},
            _b[styles.layoutGap] = "".concat(gap, "px"),
            _b[styles.layoutPadding] = "".concat(padding, "px"),
            _b[styles.layoutAlignment] = alignment,
            _b[styles.layoutColumnCount] = columns.length.toString(),
            _b)) }), columns.map(function (column, idx) {
        var _a;
        return (react_1.default.createElement(hydrationHelpers_1.ContentArea, { key: idx, style: (0, dynamic_1.assignInlineVars)((_a = {}, _a[styles.columnWidth] = column.width.toString(), _a)), className: styles.layoutColumn }, column.content));
    })));
};
exports.Layout = Layout;
